import { PaginationParams } from "../type";

export const NOTE_KEYS = {
  NOTES: "notes",
  GET_NOTES: (params?: PaginationParams) => [NOTE_KEYS.NOTES, params],
};
